import { render } from "./file.upload.vue?vue&type=template&id=fa2a2126"
import script from "./file.upload.vue?vue&type=script&lang=js"
export * from "./file.upload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__